import { DomainsPermissions } from '../../constants';
export const getPurchasePermissions = async _ref => {
  let httpClient = _ref.httpClient;
  const _await$import$Domains = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
      httpClient
    }),
    domainsAccountPermissions = _await$import$Domains.domainsAccountPermissions;
  const account = await domainsAccountPermissions({});
  if (!(account != null && account.domainPermissions)) {
    return {
      hasPermission: false
    };
  }
  const isSiteLevel = !!account.msid;
  const userPermissions = new Set(account.domainPermissions ?? []);
  return {
    hasPermission: userPermissions.has(isSiteLevel ? DomainsPermissions.SiteLevelPurchaseDomain : DomainsPermissions.AccountLevelPurchaseDomain)
  };
};
//# sourceMappingURL=getPurchasePermissions.js.map